const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  numericOnlyInput: '[data-numeric-only]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
          numericOnlyInputs: container.querySelectorAll(selectors.numericOnlyInput),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
    this.elements.numericOnlyInputs.forEach((element) => {
      this._sanitizeNumericInput(element);
      element.addEventListener('input', this._handleNumericInput);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleNumericInput = ({ currentTarget }) => {
    this._sanitizeNumericInput(currentTarget);
  };

  _sanitizeNumericInput(input) {
    input.value = input.value.replace(/\D/g, '');
  }

  /**
   * 삭제는 추가·수정(폼 제출)과 달리 POST 후 Shopify가 프로필 등으로 302를 주는 경우가 많아,
   * fetch(redirect: manual)로 응답만 받고 목적지는 data-address-delete-return-url 로 보냄.
   */
  _handleDeleteButtonClick = async ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (!confirm(currentTarget.getAttribute(attributes.confirmMessage))) return;

    const url = currentTarget.dataset.target;
    const returnContainer = currentTarget.closest(selectors.customerAddresses);
    const returnTo =
      returnContainer?.dataset?.addressDeleteReturnUrl ||
      document.querySelector(selectors.customerAddresses)?.dataset?.addressDeleteReturnUrl;

    const postLinkParams = { _method: 'delete' };
    if (returnTo) postLinkParams.return_to = returnTo;

    const body = new URLSearchParams();
    body.append('_method', 'delete');
    if (returnTo) body.append('return_to', returnTo);

    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
        redirect: 'manual',
      });

      if (response.ok) {
        window.location.assign(returnTo || window.location.href);
        return;
      }

      if (response.status === 302 || response.status === 303) {
        const nextUrl = response.headers.get('Location');
        if (returnTo && nextUrl?.includes('shopify.com')) {
          window.location.assign(returnTo);
          return;
        }
        if (nextUrl) {
          window.location.assign(nextUrl);
          return;
        }
      }

      if (response.type === 'opaqueredirect' && returnTo) {
        window.location.assign(returnTo);
        return;
      }
    } catch {
      /* 폴백 */
    }

    Shopify.postLink(url, { parameters: postLinkParams });
  };
}
